import { render, staticRenderFns } from "./Firstpage.vue?vue&type=template&id=14abc172&scoped=true"
import script from "./Firstpage.vue?vue&type=script&lang=js"
export * from "./Firstpage.vue?vue&type=script&lang=js"
import style0 from "./Firstpage.vue?vue&type=style&index=0&id=14abc172&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14abc172",
  null
  
)

export default component.exports